export interface IFreeInputable {
  isFreeInputable: boolean;
  shouldInputFree: boolean;
}

export function instanceOfIFreeInputable(instance: any): instance is IFreeInputable {
  return instance
    && (instance.isFreeInputable !== undefined)
    && (instance.shouldInputFree !== undefined);
}
